export const breakpoints = {
    lg: 992,
    md: 768,
    sm: 375,
    xl: 1440,
};
